import { Component, EventEmitter, Input, Output } from '@angular/core';

import { ApiError, MessageService } from '../../../../../core';
import { ClienteAnaliseMercadoProjecaoClassificacaoSearch } from '../cliente-analise-mercado-projecao-classificacao-search';
import { ClienteAnaliseMercadoProjecaoClassificacaoHttpService } from '../services';

@Component({
    selector: 'sgt-cliente-analise-mercado-projecao-classificacao-pipeline-card',
    templateUrl: './cliente-analise-mercado-projecao-classificacao-pipeline-card.component.html',
    styleUrls: ['./cliente-analise-mercado-projecao-classificacao-pipeline-card.component.less']
})
export class ClienteAnaliseMercadoProjecaoClassificacaoPipelineCardComponent {
    /** Se controla lançamentos por quantidade */
    @Input() controleQuantidade: boolean;
    /** Se controla lançamentos por peso */
    @Input() controlePeso: boolean;
    /** Se controla lançamentos por valor */
    @Input() controleValor: boolean;
    /** ID do cliente para pesquisar as projeções das classificações */
    @Input() idCliente: number;
    /** Mês das projeções */
    @Input() mes: number;
    /** Ano das projeções */
    @Input() ano: number;
    /** Status das projeções */
    @Input() statusProjetado: number;
    /** ID da etapa de negociação das projeções */
    @Input() idEtapaNegociacaoProjecao: number;
    /** ID's das classificações filtras */
    // @Input() idsClassificacoes: number[] = [];

    /** Indicador se está carregando as projeções das classificações */
    @Input() isLoading: boolean;
    /** Emite evento ao alterar o indicador se está carregando as projeções das classificações */
    @Output() isLoadingChange = new EventEmitter<boolean>();
    /** Indicador se já carregou as projeções das classificações */
    @Input() isLoaded: boolean;
    /** Emite evento ao alterar o indicador se já carregou as projeções das classificações */
    @Output() isLoadedChange = new EventEmitter<boolean>();
    /** Projeções das undiades de negócios */
    @Input() entities: ClienteAnaliseMercadoProjecaoClassificacaoSearch[];
    /** Emite evento ao alterar as projeções das undiades de negócios */
    @Output() entitiesChange = new EventEmitter<ClienteAnaliseMercadoProjecaoClassificacaoSearch[]>();

    constructor(private messageService: MessageService,
                private clienteAnaliseMercadoProjecaoClassificacaoHttpService: ClienteAnaliseMercadoProjecaoClassificacaoHttpService) { }

    /** Realiza a pesquisa das projeções das classificações do cliente */
    search() {
        this.setIsLoading(true);
        this.setIsLoaded(false);
        this.clienteAnaliseMercadoProjecaoClassificacaoHttpService.search(this.idCliente, this.mes, this.ano, this.statusProjetado, this.idEtapaNegociacaoProjecao)
            .subscribe(
                entities => {
                    this.setEntities(entities);
                    this.setIsLoading(false);
                    this.setIsLoaded(true);
                },
                (error: ApiError) => {
                    this.messageService.error(error.message,  'Erro ao pesquisar as projeções dos segmentos', error);
                    this.setIsLoading(false);
                    this.setEntities([]);
                }
            );
    }

    /** Seta o indicador se está carregando as projeções das classificações  */
    private setIsLoading(value: boolean) {
       this.isLoading = value;
       this.isLoadingChange.emit(value);
    }

    /** Seta o indicador se já carregou as projeções das classificações */
    private setIsLoaded(value: boolean) {
        this.isLoaded = value;
        this.isLoadedChange.emit(value);
    }

    /** Seta as projeções das undiades de negócios */
    private setEntities(value: ClienteAnaliseMercadoProjecaoClassificacaoSearch[]) {
        this.entities = value;
        this.entitiesChange.emit(value);
    }
}
